import { ErrorType, WalletException, UnspecifiedErrorCode, } from '@injectivelabs/exceptions';
import { DEFAULT_TURNKEY_REFRESH_SECONDS, TURNKEY_OTP_INIT_PATH, TURNKEY_OTP_VERIFY_PATH, } from '../consts.js';
export class TurnkeyOtpWallet {
    static async initEmailOTP(args) {
        const { client, indexedDbClient, expirationSeconds } = args;
        try {
            await indexedDbClient.resetKeyPair();
            let publicKey = await indexedDbClient.getPublicKey();
            if (!publicKey) {
                throw new WalletException(new Error('Public key not found'));
            }
            // client.$post is undefined, resorting to this for now
            const response = await client.post(args.otpInitPath || TURNKEY_OTP_INIT_PATH, {
                targetPublicKey: publicKey,
                email: args.email,
                suborgId: args.subOrgId,
                invalidateExistingSessions: args.invalidateExistingSessions,
                isUsingIndexedDB: true,
                expirationSeconds: expirationSeconds || DEFAULT_TURNKEY_REFRESH_SECONDS,
            });
            return response?.data;
        }
        catch (e) {
            throw new WalletException(new Error(e.message), {
                code: UnspecifiedErrorCode,
                type: ErrorType.WalletError,
                contextModule: 'turnkey-init-email-otp',
            });
        }
    }
    static async confirmEmailOTP(args) {
        const { client, expirationSeconds, targetPublicKey } = args;
        try {
            const organizationId = args.organizationId;
            const emailOTPId = args.emailOTPId;
            const otpVerifyPath = args.otpVerifyPath || TURNKEY_OTP_VERIFY_PATH;
            if (!emailOTPId) {
                throw new WalletException(new Error('Email OTP ID is required'));
            }
            if (!organizationId) {
                throw new WalletException(new Error('Organization ID is required'));
            }
            const response = await client.post(otpVerifyPath, {
                isUsingIndexedDB: true,
                targetPublicKey,
                otpId: emailOTPId,
                otpCode: args.otpCode,
                suborgID: organizationId,
                expirationSeconds: (expirationSeconds || DEFAULT_TURNKEY_REFRESH_SECONDS)?.toString(),
            });
            return response?.data;
        }
        catch (e) {
            throw new WalletException(new Error(e.message), {
                code: UnspecifiedErrorCode,
                type: ErrorType.WalletError,
                contextModule: 'turnkey-confirm-email-otp',
            });
        }
    }
}
